import { RawOrderStatus } from "@/orders/entities";

export class OrderStatus {
  readonly id: string;
  readonly code: string;
  readonly description: string;

  constructor(data: RawOrderStatus) {
    this.id = data.id;
    this.code = data.code;
    this.description = data.description;
  }
}
